// extracted by mini-css-extract-plugin
export var dividerLine = "_5x-3";
export var itemImage = "_5x-9";
export var lightDivider = "_5x-4";
export var modalContent = "_5x-5";
export var modalContentCompact = "_5x-6";
export var productCard = "_5x-a";
export var productImage = "_5x-b";
export var productImageCompact = "_5x-7";
export var productImagePlaceholder = "_5x-c";
export var productImagePlaceholderCompact = "_5x-8";
export var progressBarBackground = "_5x-1";
export var progressBarContainer = "_5x-0";
export var progressBarFill = "_5x-2";